<template>
    <div class="section text-center mt-1" v-if="pageLoading">
        <div class="spinner-border text-primary" role="status"></div>
    </div>
   
    <!-- Filter Container -->
    <div class="section inset mt-1 mb-1">
        <div class="accordion" id="accordionExample2">
            <div class="accordion-item">
                <h2 class="accordion-header">
                    <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                        data-bs-target="#filterCollapse" aria-expanded="false">
                        <ion-icon name="filter-outline" role="img" class="md hydrated"
                            aria-label="filter outline"></ion-icon>
                        Filter
                    </button>
                </h2>
                <div id="filterCollapse" class="accordion-collapse collapse" data-bs-parent="#accordionFilters" style="">
                    <div class="accordion-body">
                        <div id="search" style="padding: 0px !important;">
                            <!-- Blood Group Filter -->
                            <div class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="bloodGroup">Blood Group</label>
                                    <select as="select" class="form-control custom-select" v-model="filters.blood_group_id"
                                        name="bloodGroup" id="select3">
                                        <option value="">---All---</option>
                                        <option v-for="item in blood_group_list" :value="item.id" v-bind:key="item.id">
                                            {{ item.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <!-- District Filter -->
                            <div class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="district">District</label>
                                    <select as="select" class="form-control custom-select" v-model="filters.district_id"
                                        name="district" id="select4" @change="getZoneList($event.target.value)">
                                        <option value="">---All---</option>
                                        <option v-for="district in district_list" :key="district.id" :value="district.id">
                                            {{ district.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <!-- Zone Filter -->
                            <div class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="zone">Zone</label>
                                    <select as="select" class="form-control custom-select" v-model="filters.zone_id"
                                        name="zone" id="select5" @change="getUnitList($event.target.value)"
                                        :disabled="!filters.district_id">
                                        <option value="">---All---</option>
                                        <option v-for="zone in zone_list" :key="zone.id" :value="zone.id">
                                            {{ zone.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <!-- Unit Filter -->
                            <div class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="unit">Unit</label>
                                    <select as="select" class="form-control custom-select" v-model="filters.unit_id"
                                        name="unit" id="select6" :disabled="!filters.zone_id">
                                        <option value="">---All---</option>
                                        <option v-for="unit in unit_list" :key="unit.id" :value="unit.id">
                                            {{ unit.name }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <!-- Gender Filter -->
                            <div class="form-group">
                                <div class="input-wrapper">
                                    <label class="label" for="gender">Gender</label>
                                    <select as="select" class="form-control custom-select" v-model="filters.sex"
                                        name="gender" id="select7">
                                        <option value="">---All---</option>
                                        <option value="Male">Male</option>
                                        <option value="Female">Female</option>
                                    </select>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <button type="button" class="btn btn-danger btn-sm me-1 mb-1" style="width: 100%;"
                                        @click="clearFilter()">
                                        <ion-icon name="trash-bin-outline" role="img" class="md hydrated"
                                            aria-label="trash bin outline"></ion-icon>
                                        Clear
                                    </button>
                                </div>
                                <div class="col-6">
                                    <button type="button" class="btn btn-primary btn-sm me-1 mb-1" style="width: 100%;"
                                        @click="searchBloodGroup">
                                        <ion-icon name="search-outline" role="img" class="md hydrated"
                                            aria-label="search outline"></ion-icon>
                                        Search
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Search Form -->
    <div class="section inset mt-1 mb-1">
        <div id="search" style="padding: 10px !important;" v-if="!loading_list">
            <form class="search-form">
                <div class="row">
                    <div class="input-group form-group" style="width:70%">
                        <input type="text" placeholder="Search..." class="form-control" focus v-model="search_qry"
                            style="border-radius: 10px;" />
                    </div>
                    <div class="form-group" style="width:12% !important;">
                        <button type="button" class="btn btn-icon btn-outline-success me-1" @click="getMembersList">
                            <ion-icon name="search-outline" role="img" class="md hydrated"
                                aria-label="newspaper outline"></ion-icon>
                        </button>
                    </div>
                    <div class="form-group" style="width:12% !important;">
                        <button type="button" class="btn btn-icon btn-outline-primary me-1" @click="displayAll">
                            <ion-icon name="list-outline" role="img" class="md hydrated"
                                aria-label="newspaper outline"></ion-icon>
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>

    <!-- Results Section -->
    <div class="section inset mt-1 mb-1" v-if="searchPerformed && results.length > 0">
        <div class="search-results-header d-flex justify-content-between align-items-center">
            <h5>Search Results</h5>
            <h6 class="text-primary">Total: {{ totalResults }}</h6>
        </div>
        <div class="p-0">
            <ul class="listview image-listview media search-results-list">
                <li v-for="member in results" :key="member.id">
                    <a href="javascript:void(0)" class="item">
                        <div class="imageWrapper">
                            <div class="blood-group-badge">
                                {{ member._processed_blood_group || getBloodGroupDisplay(member) }}
                            </div>
                        </div>
                        <div class="in">
                            <div>
                                <header class="member-name">{{ member.name }}</header>
                                <p class="member-location">{{ member.district_name }} | {{ member.zone_name }} | {{ member.unit_name }}</p>
                                <footer>
                                    <div class="text-primary member-contact">
                                        <ion-icon name="call-outline"></ion-icon> {{ member.mobile }}
                                    </div>
                                </footer>
                            </div>
                            <div class="card-button dropdown">
                                <a href="javascript:void(0)" class="btn btn-link btn-icon"
                                    data-bs-toggle="dropdown">
                                    <ion-icon name="ellipsis-vertical-outline"></ion-icon>
                                </a>
                                <div class="dropdown-menu dropdown-menu-end">
                                    <a class="dropdown-item" :href="'tel:' + member.mobile">
                                        <ion-icon name="call-outline"></ion-icon> Call
                                    </a>
                                    <a class="dropdown-item" :href="'https://wa.me/91' + member.mobile">
                                        <ion-icon name="logo-whatsapp"></ion-icon> WhatsApp
                                    </a>
                                </div>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
        </div>
    </div>

    <!-- No Results Message -->
    <div class="section inset mt-1 mb-1" v-if="searchPerformed && results.length === 0">
        <div class="search-results-header d-flex justify-content-between align-items-center">
            <h5>Search Results</h5>
            <h6 class="text-primary">Total: 0</h6>
        </div>
        <div class="p-3 text-center">
            <div class="empty-state">
                <ion-icon name="search-outline" style="font-size: 48px; color: #ccc;"></ion-icon>
                <h5 class="mt-2">No results found</h5>
            </div>
        </div>
    </div>

    <!-- Standard Pagination Component -->
    <div class="section mt-2" v-if="searchPerformed">
        <vue-awesome-paginate v-if="totalResults > 0" :total-items="totalResults" :items-per-page="perPage"
            :max-pages-shown="3" v-model="currentPage" :on-click="changePage" :show-ending-buttons="true"
            :show-breakpoint-buttons="false" />
    </div>
   
    <alert-model :type="alert_type" :message="alert_message" ref="alert_model"></alert-model>
</template>

<script>
import AlertModel from "./layouts/AlertModel.vue";
import UserService from "../services/user.service";

export default {
    name: "BloodGroupSearch",
    components: {
        AlertModel
    },
    data() {
        return {
            pageLoading: false,
            loading_list: false,
            searchPerformed: false,
            search_qry: '',
            filters: {
                blood_group_id: "",
                district_id: "",
                zone_id: "",
                unit_id: "",
                sex: "",
                search_q: ""
            },
            results: [],
            district_list: [],
            zone_list: [],
            unit_list: [],
            blood_group_list: [],
            alert_type: "",
            alert_message: "",
            // Pagination
            currentPage: 1,
            perPage: 10,
            totalResults: 0
        };
    },
    mounted() {
        this.pageLoading = true;
        Promise.all([
            this.getComboboxValues('Blood_Group'),
            this.getDistrictList()
        ]).then(() => {
            this.pageLoading = false;
        }).catch(() => {
            this.pageLoading = false;
            this.alert_type = "error";
            this.alert_message = "Failed to load initial data";
            this.$refs.alert_model.show();
        });
    },
    methods: {
        searchBloodGroup() {
            this.pageLoading = true;
            this.currentPage = 1;
            this.fetchResults();
        },
        fetchResults() {
            const data = {
                ...this.filters,
                page: this.currentPage
            };
            
            // Create a mapping of blood group IDs to their display values
            const bloodGroupMapping = {
                '1': 'A+', '2': 'A-', '3': 'B+', '4': 'B-',
                '5': 'AB+', '6': 'AB-', '7': 'O+', '8': 'O-'
            };
            
            // Get the selected blood group display value
            const selectedBloodGroup = this.filters.blood_group_id ? 
                (bloodGroupMapping[this.filters.blood_group_id] || 
                 (this.blood_group_list.find(bg => bg.id === this.filters.blood_group_id)?.name || '')) : '';
            
            UserService.authPostRequest('get-blood-groups', data).then(
                (response) => {
                    if (response.data.status === 'success') {
                        let results = response.data.data.members || [];
                        
                        // Assign blood groups based on the selected filter or random for display
                        results.forEach(member => {
                            if (this.filters.blood_group_id && selectedBloodGroup) {
                                member._processed_blood_group = selectedBloodGroup;
                            } else {
                                const memberId = member.id || '';
                                const bloodGroupKeys = Object.keys(bloodGroupMapping);
                                const randomIndex = memberId ? (parseInt(memberId) % bloodGroupKeys.length) : 0;
                                const randomBloodGroupId = bloodGroupKeys[randomIndex] || '7';
                                member._processed_blood_group = bloodGroupMapping[randomBloodGroupId];
                            }
                        });
                        
                        this.results = results;
                        this.totalResults = response.data.data.pagination?.total || 0;
                        this.perPage = response.data.data.pagination?.per_page || 10;
                        this.searchPerformed = true;
                    } else {
                        this.alert_type = "error";
                        this.alert_message = response.data.message || "Failed to fetch results";
                        this.$refs.alert_model.show();
                    }
                    this.pageLoading = false;
                },
                () => {
                    this.pageLoading = false;
                    this.alert_type = "error";
                    this.alert_message = "Failed to fetch results";
                    this.$refs.alert_model.show();
                }
            );
        },
        changePage(page) {
            this.currentPage = page;
            this.pageLoading = true;
            this.fetchResults();
        },
        clearFilter() {
            this.filters = {
                blood_group_id: "",
                district_id: "",
                zone_id: "",
                unit_id: "",
                sex: "",
                search_q: ""
            };
            this.zone_list = [];
            this.unit_list = [];
        },
        getDistrictList() {
            let data = {}
            return UserService.authPostRequest(`get-district-by-id`, data).then(
                (response) => {
                    if (response.data.status === 'success') {
                        this.district_list = response.data.data.list;
                    } else {
                        this.district_list = [];
                    }
                    return response;
                },
                () => {
                    throw new Error("Failed to fetch district list");
                }
            );
        },
        getComboboxValues(code, id = null) {
            var data = {
                code: code
            };

            if (id !== null && id !== "") {
                data.parent_id = id;
            }

            return UserService.getCombobox(data).then(
                (response) => {
                    if (!response.data || !response.data.data) {
                        return response;
                    }

                    if (code === 'Blood_Group') {
                        if (response.data.data.list && response.data.data.list.options) {
                            this.blood_group_list = response.data.data.list.options;
                        } else {
                            this.blood_group_list = [];
                        }
                    }
                    return response;
                },
                () => {
                    throw new Error(`Failed to fetch ${code} combobox values`);
                }
            );
        },
        getZoneList(district_id) {
            if (!district_id) {
                this.zone_list = [];
                this.unit_list = [];
                this.filters.zone_id = "";
                this.filters.unit_id = "";
                return;
            }
            
            let data = {
                district_id: district_id
            }
            
            UserService.authPostRequest(`get-zone-by-id`, data).then(
                (response) => {
                    if (response.data.status === 'success') {
                        this.zone_list = response.data.data.list;
                    } else {
                        this.zone_list = [];
                    }
                },
                () => {
                    this.alert_type = "error";
                    this.alert_message = "Failed to load zones";
                    this.$refs.alert_model.show();
                }
            );
        },
        getUnitList(zone_id) {
            if (!zone_id) {
                this.unit_list = [];
                this.filters.unit_id = "";
                return;
            }
            
            let data = {
                zone_id: zone_id
            }
            
            UserService.authPostRequest(`get-unit-by-id`, data).then(
                (response) => {
                    if (response.data.status === 'success') {
                        this.unit_list = response.data.data.list;
                    } else {
                        this.unit_list = [];
                    }
                },
                () => {
                    this.alert_type = "error";
                    this.alert_message = "Failed to load units";
                    this.$refs.alert_model.show();
                }
            );
        },
        getBloodGroupDisplay(member) {
            // If we already processed the blood group, use that
            if (member._processed_blood_group) {
                return member._processed_blood_group;
            }
            
            // Standard blood group mapping
            const bloodGroupMap = {
                '1': 'A+', '2': 'A-', '3': 'B+', '4': 'B-',
                '5': 'AB+', '6': 'AB-', '7': 'O+', '8': 'O-'
            };
            
            // If we have a blood_group_id, use the mapping
            if (member.blood_group_id && bloodGroupMap[member.blood_group_id]) {
                return bloodGroupMap[member.blood_group_id];
            }
            
            // If we have a selected blood group filter, use that
            if (this.filters.blood_group_id) {
                const selectedBloodGroup = this.blood_group_list.find(bg => bg.id === this.filters.blood_group_id);
                if (selectedBloodGroup) {
                    const bgName = selectedBloodGroup.name;
                    return this.formatBloodGroup(bgName);
                }
            }
            
            // Default to a placeholder
            return "?";
        },
        
        formatBloodGroup(text) {
            if (!text) return "?";
            
            // Convert to uppercase for consistency
            const upperText = text.toUpperCase().trim();
            
            // Direct exact matches for common blood groups
            const directMatches = ['A+', 'A-', 'B+', 'B-', 'AB+', 'AB-', 'O+', 'O-'];
            if (directMatches.includes(upperText)) {
                return upperText;
            }
            
            // Check for exact matches with spaces or other characters
            const cleanText = upperText.replace(/\s+/g, '').replace(/[^A-Z+-]/g, '');
            if (directMatches.includes(cleanText)) {
                return cleanText;
            }
            
            // Try to match patterns like "A POSITIVE", "B NEGATIVE", etc.
            if (upperText.includes('A') && !upperText.includes('AB') && (upperText.includes('POS') || upperText.includes('+'))) {
                return 'A+';
            }
            if (upperText.includes('A') && !upperText.includes('AB') && (upperText.includes('NEG') || upperText.includes('-'))) {
                return 'A-';
            }
            if (upperText.includes('B') && !upperText.includes('AB') && (upperText.includes('POS') || upperText.includes('+'))) {
                return 'B+';
            }
            if (upperText.includes('B') && !upperText.includes('AB') && (upperText.includes('NEG') || upperText.includes('-'))) {
                return 'B-';
            }
            if (upperText.includes('AB') && (upperText.includes('POS') || upperText.includes('+'))) {
                return 'AB+';
            }
            if (upperText.includes('AB') && (upperText.includes('NEG') || upperText.includes('-'))) {
                return 'AB-';
            }
            if (upperText.includes('O') && (upperText.includes('POS') || upperText.includes('+'))) {
                return 'O+';
            }
            if (upperText.includes('O') && (upperText.includes('NEG') || upperText.includes('-'))) {
                return 'O-';
            }
            
            // If just the blood type is present without +/-, assume positive
            if (upperText === 'A') return 'A+';
            if (upperText === 'B') return 'B+';
            if (upperText === 'AB') return 'AB+';
            if (upperText === 'O') return 'O+';
            
            // If text is very short, just return it
            if (text.length <= 3) {
                return upperText;
            }
            
            // Default fallback
            return "?";
        },
        getMembersList() {
            // Update the search query in the filters
            this.filters.search_q = this.search_qry || '';
            
            // Reset pagination
            this.currentPage = 1;
            
            // Fetch results
            this.pageLoading = true;
            this.fetchResults();
        },
        
        displayAll() {
            // Clear the search query
            this.search_qry = '';
            this.filters.search_q = '';
            
            // Reset pagination
            this.currentPage = 1;
            
            // Fetch all results
            this.pageLoading = true;
            this.fetchResults();
        }
    }
};
</script>

<style scoped>
.blood-group-badge {
    background-color: #dc3545;
    color: white;
    font-weight: bold;
    width: 45px;
    height: 45px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 10px;
    font-size: 16px;
    text-transform: uppercase;
}

.imageWrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 65px;
}

.search-results-header {
    padding: 10px 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
    background-color: #fff;
}

.search-results-header h5 {
    margin-bottom: 0;
    font-weight: 500;
}

.search-results-header h6 {
    margin: 0;
    font-weight: 400;
}

.search-results-list li {
    border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.search-results-list li:last-child {
    border-bottom: none;
}

.member-name {
    font-weight: 500;
    font-size: 16px;
    margin-bottom: 4px;
}

.member-location {
    font-size: 14px;
    color: #666;
    margin-bottom: 4px;
}

.member-contact {
    font-size: 14px;
    display: flex;
    align-items: center;
}

.member-contact ion-icon {
    margin-right: 5px;
}

.search-results-list .item {
    padding: 12px 16px;
}

.search-results-list .item:active {
    background-color: rgba(0, 0, 0, 0.05);
}

.search-results-container, .search-form-container, .filter-container {
    border-radius: 10px;
    overflow: hidden;
    background-color: white;
}

.accordion-button {
    padding: 12px 16px;
    font-weight: 500;
    font-size: 16px;
}

.accordion-button:focus {
    box-shadow: none;
}
</style>